import gql from "graphql-tag";

export const CREATE_RULE = gql`
  mutation CreateRule($data: RuleDataInput) {
    createRule(data: $data) {
      id
    }
  }
`;

const rules = { CREATE_RULE };

export default rules;
